var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilletera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 57.5,
    viewBox: "0 0 69 57.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.25,26.367V11.992H57.5V.492H8.625A8.613,8.613,0,0,0,0,9.117V57.992H54.625a8.613,8.613,0,0,0,8.625-8.625v-5.75A5.767,5.767,0,0,0,69,37.867v-5.75A5.767,5.767,0,0,0,63.25,26.367ZM8.625,6.242H51.75v5.75H8.625a2.875,2.875,0,1,1,0-5.75Zm46,46H5.75V17.225a8.638,8.638,0,0,0,2.875.517H57.5v8.625a8.625,8.625,0,0,0,0,17.25v5.75A2.883,2.883,0,0,1,54.625,52.242ZM57.5,37.867a2.875,2.875,0,0,1,0-5.75h5.75v5.75Z",
    transform: "translate(0 -0.492)",
    fill: "#00c1d4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilletera);
export default __webpack_public_path__ + "static/media/billetera.3d8bdae7072ed8410b17ea28efbdcfe7.svg";
export { ForwardRef as ReactComponent };